/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "internal": {
            "nested": {
              "message": {
                "nested": {
                  "UpdateDeviceCodeRequest": {
                    "fields": {
                      "deviceCodeId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "UpdateDeviceCodeResponse": {
                    "fields": {
                      "error": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.internal?.nested?.message?.nested?.UpdateDeviceCodeRequest && !$root.nested?.squareup?.nested?.devicesettings?.nested?.internal?.nested?.message?.nested?.UpdateDeviceCodeResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateDeviceCodeRequest @ squareup/devicesettings/internal/message/update_device_code.proto at 12:1
 */
export const UpdateDeviceCodeRequest = $root.lookupType('squareup.devicesettings.internal.message.UpdateDeviceCodeRequest');
fixType(UpdateDeviceCodeRequest, {
  deviceCodeId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateDeviceCodeRequest);
/**
 * SOURCE UpdateDeviceCodeResponse @ squareup/devicesettings/internal/message/update_device_code.proto at 17:1
 */
export const UpdateDeviceCodeResponse = $root.lookupType('squareup.devicesettings.internal.message.UpdateDeviceCodeResponse');
fixType(UpdateDeviceCodeResponse);
Builder.createAndAttachToType(UpdateDeviceCodeResponse);